<template>
  <div class="animated fadeIn list-of-procure">
    <b-card>
      <div slot="header">
        PO, INVOICE & PAYMENT HISTORY TRANSACTION
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="print()">
            <i class="fa fa-print"></i> Print
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col md="4">
          <b-input-group>
            <b-input-group-prepend>
              <label>Supplier/Vendor</label>
            </b-input-group-prepend>
            <b-form-input readonly v-model="model.vendorinfo" :state="!$v.model.vendor.$error"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuVendorShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col md="2">
          <b-input-group>
            <b-input-group-prepend>
              <span class="input-group-text">Currency</span>
            </b-input-group-prepend>
            <b-form-select
              v-model="model.matauang"
              :plain="true"
              :state="!$v.model.matauang.$error"
              :options="currency"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col md="3">
          <b-input-group>
            <b-input-group-prepend>
              <label>As of Date</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.tgl2" type="date" placeholder="until date"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="2">
          <b-button class="btn btn-success" @click="getData()">
            <i class="fa fa-play"></i> Process
          </b-button>
        </b-col>
      </b-row>
      <b-card no-body>
        <template v-slot:header v-if="(filterShow=='Hide')">
          <b-row>
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox
                    v-for="(item,index) in tblLcy.fields.filter(x=>x.filterable)"
                    :key="index"
                    :value="item.key"
                  >{{item.label}}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
        <b-table
          class="mb-0"
          ref="tableOri"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          bordered
          style="font-size:smaller;"
          :items="rptLines"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
          @row-clicked="confirmAction"
          show-empty
        >
          <template v-slot:cell(tanggal)="data">
            <span v-if="data.item.tanggal">{{data.item.tanggal | moment("DD MMM YYYY")}}</span>
          </template>
          <template v-slot:cell(totalpo)="data">
            <span v-if="data.item.totalpo">{{data.item.totalpo | numFormat}}</span>
          </template>
          <template v-slot:cell(totalap)="data">
            <span v-if="data.item.totalap">{{data.item.totalap | numFormat}}</span>
          </template>
          <template v-slot:cell(nilaibayar)="data">
            <span v-if="data.item.nilaibayar">{{data.item.nilaibayar | numFormat}}</span>
          </template>
          <template v-slot:cell(unBilled)="data">
            <span v-if="data.item.unBilled">{{data.item.unBilled | numFormat}}</span>
          </template>
          <template v-slot:cell(outstand)="data">
            <span v-if="data.item.outstand">{{data.item.outstand | numFormat}}</span>
          </template>
          <template v-slot:empty="scope">
            <h6 class="text-center">{{ scope.emptyText }}</h6>
          </template>
          <template v-slot:emptyfiltered="scope">
            <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
          </template>
          <template v-slot:custom-foot="data">
            <b-tr>
              <b-td class="tebal" style="text-align:right" colspan="8">SUB TOTAL : &nbsp;</b-td>
              <b-td class="total" style="text-align:right">{{subtotal.totalpo | numFormat}}</b-td>
              <b-td class="total" style="text-align:right">{{subtotal.totalap | numFormat}}</b-td>
              <b-td class="total" style="text-align:right">{{subtotal.totalbyr | numFormat}}</b-td>
              <b-td class="total" style="text-align:right">{{subtotal.unBilled | numFormat}}</b-td>
              <b-td class="total" style="text-align:right">{{subtotal.outstand | numFormat}}</b-td>
            </b-tr>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="4">
            <div class="ml-1">
              Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
              to
              <span
                v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
              >{{tblLcy.total}}</span>
              <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
              of {{tblLcy.total}} entries.
            </div>
          </b-col>
          <b-col cols="4" align="center">
            <span class="mr-1">limit per page :</span>
            <select v-model="tblLcy.limit" style="width:60px;">
              <option>10</option>
              <option>15</option>
              <option>20</option>
              <option>25</option>
              <option>30</option>
              <option>40</option>
              <option>50</option>
              <option>60</option>
              <option>70</option>
              <option>80</option>
              <option>90</option>
            </select>
            <b-form-checkbox
              v-model="filterShow"
              value="Hide"
              unchecked-value="Show"
              switch
              class="ml-2"
            >
              <b>{{ filterShow }}</b> Filter
            </b-form-checkbox>
          </b-col>
          <b-col cols="4">
            <b-pagination
              class="ml-1"
              align="right"
              :total-rows="tblLcy.total"
              :per-page="tblLcy.limit"
              v-model="tblLcy.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="lkuVendorShow"
      size="lg"
      :hide-footer="true"
      title="List of Vendor"
      :centered="true"
    >
      <lku-vendor @click="onSelectLkuVendor"></lku-vendor>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.report-wraper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;

  table {
    font-size: smaller;
    th {
      border-bottom: 1px solid #d1d1d1;
      padding: 0 15px;
      height: 30px;
      background: #e8e8e8;
    }
    td {
      border-bottom: 1px solid #f5f5f5;
      padding: 0 10px;
      height: 25px;
    }

    td.tebal {
      font-weight: bold;
    }

    td.payment {
      font-style: italic;
      background-color: rgba(0, 0, 0, 0.05) !important;
    }

    td.subtotal {
      border-top: 2px solid #000 !important;
    }

    td.total {
      border-top: 2px solid #000 !important;
      background: #e6e6e6 !important;
      height: 40px;
    }

    td.grdtotal {
      border-top: 2px solid #000 !important;
      border-bottom: 2px double #000 !important;
      background: #e6e6e6 !important;
    }
    tbody tr:hover {
      background-color: rgba(91, 192, 222, 0.2) !important;
      cursor: default;
    }
  }
}
iframe {
  border: 1px solid #ccc;
  width: 100%;
  height: 11in;
}
</style>

<script>
import moment from "moment";
import procure from "../../apis/procure";
import lkuVendor from "../lookup/lkuVendor";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      vendor: { required },
      matauang: { required },
      tgl2: { required }
    }
  },
  data() {
    return {
      horizontal: true,
      isLoading: false,
      showReport: false,
      lkuVendorShow: false,
      reportUrl: null,
      model: {
        vendorinfo: "",
        vendor: "",
        matauang: this.$store.state.user.matauang,
        tgl2: "",
        alltrx: 0
      },
      currency: [],
      rptLines: [],
      subtotal: { debit: 0, credit: 0, outstand: 0 },
      // ==================
      filterShow: "Show",
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "tanggal",
            label: "Trx. Date",
            sortable: true,
            filterable: true
          },
          {
            key: "po",
            label: "PO. Number",
            sortable: true,
            filterable: true
          },
          {
            key: "invoice",
            label: "Invoice#",
            sortable: true,
            filterable: true
          },
          {
            key: "nomor",
            label: "AP. Number",
            sortable: true,
            filterable: true
          },
          {
            key: "nomorbk",
            label: "Payment Number",
            sortable: true,
            filterable: true
          },
          {
            key: "paymethod",
            label: "Payment Method",
            sortable: true,
            filterable: true
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true,
            filterable: true
          },
          {
            key: "matauang",
            label: "$,¥",
            sortable: true
            // filterable:true
          },
          {
            key: "totalpo",
            label: "PO Amount",
            tdClass: "text-right",
            sortable: true,
            filterable: true
          },
          {
            key: "totalap",
            label: "Invoice (Bill)\n Amount",
            tdClass: "text-right",
            sortable: true,
            filterable: true
          },
          {
            key: "nilaibayar",
            label: "Payment Amount",
            tdClass: "text-right",
            sortable: true,
            filterable: true
          },
          {
            key: "unBilled",
            label: "Outstand PO \n (Un Bill)",
            tdClass: "text-right",
            sortable: true,
            filterable: true
          },
          {
            key: "outstand",
            label: "Outstand Invoice",
            tdClass: "text-right",
            sortable: true,
            filterable: true
          }
        ]
      },
      filter: null,
      filterOn: []
    };
  },
  components: { Loading, lkuVendor },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    }
  },
  created: async function() {
    this.currency = await procure.currency();
    //   const matauang = await procure.currency();
    //   this.currency = matauang.reduce((newArr,item) =>{
    //         newArr.push(item);
    //         return newArr;
    //     },[{ value: '', text: '-ALL-'}]);

    const tgl2 = moment(this.$store.state.user.tglaktif, "YYYY-MM-DD")
      .add(1, "M")
      .subtract(1, "day");
    // this.filter.tgl1=this.$store.state.user.tglaktif;
    this.model.tgl2 = tgl2.format("YYYY-MM-DD");
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    onSelectLkuVendor: async function(_selected) {
      this.model.vendorinfo =
        _selected.vendor_code.trim() + " | " + _selected.vendor_code.trim();
      this.model.vendor = _selected.vendor_code;
      this.lkuVendorShow = false;
    },
    getData: async function(ctx) {
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        const result = await procure.trxvendor(this.model);
        if (result.success) {
          this.rptLines = result.data[0];
          console.log('this.rptLines',this.rptLines);
          this.tblLcy.total = result.data[0].length;
          this.subtotal = result.data[2];
        } else {
          toastr.error(result.message, "ERROR", 10000);
        }

        this.isLoading = false;
      }
    },
    confirmAction: function() {
      toastr.info("Klik Pada TRX. NUMBER untuk PRINT VOUCHER");
    },
    printJv: async function(data) {
      this.showConfirmAction = false;
      this.showList = false;
      if (data.nomor !== "BEGINING" && data.nomor !== "") {
        this.isLoading = true;
        try {
                this.showReport=true;
          this.reportUrl = await procure.printjv(data);
          this.isLoading = false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    print: async function() {
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
                this.showReport=true;
          this.reportUrl = await procure.trxvendorprint(this.model);
          this.isLoading = false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    exportxls: async function() {
      if (this.invalidModel) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await procure.trxvendorexport(this.model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push("/treasury/home");
    }
  }
};
</script>
